<template>
  <div id="app" :class="{'safari': safari, 'notPhone': notPhone}" class="allCenter" :style="{ 'max-width': webWidth + 'px' }">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    safari () {
      return this.$store.state.safari
    },
    webWidth () {
      return this.$store.state.webWidth
    }
  },
  data () {
    return {
      notPhone: false
    }
  },
  created () {
    let agent = window.navigator.userAgent
    // let systemMac = agent.indexOf("Mac OS")
    let systemPho = agent.indexOf("Pho")
    let systemAnd = agent.indexOf("And")
    if (systemPho > 0 || systemAnd > 0) {
      //移动端
      this.notPhone = false
      this.$store.commit('SET_WEBWIDTH', document.documentElement.clientWidth)
    } else {
      //pc端
      this.$store.commit('SET_WEBWIDTH', 375)
      this.notPhone = true
    }
  }
}
</script>
<style lang="scss">
@import './map.css';
@import './global.scss';
</style>
